import axios from "axios";

export const studentTrackHistoryApi = {
  history: async (studentId: string, params: { sessionId?: string; module?: string; dateFrom?: string; dateTo?: string; page?: number; limit?: number }) => {
    const res = await axios.get(`/scholar-register/student-track-history/${studentId}`, { params });
    return res.data as { items: any[]; total: number; page: number; limit: number; student: any };
  },
};
